<ul class="pl-0 flex flex-col gap-2">
    <li 
    (click)="selectOption()"
    class="
    text-surface-400/80
    hover:bg-primary-100
    hover:text-primary-600
    hover:dark:bg-surface-950
    rounded-md
    cursor-pointer p-1.5 list-none sidebar-menu-item flex flex-row gap-1 justify-start items-center" *ngFor="let item of homeItems" 
    [routerLink]="[item.route]" 
    routerLinkActive #rla="routerLinkActive"
    [ngClass]="{ 'bg-primary-100 dark:bg-surface-950 !text-primary-600 font-medium': rla.isActive }">
        <i class="{{item.icon}} text-lg"></i> <span>{{item.label}}</span>
    </li>
</ul>